import Vue from 'vue';

Vue.component('role-index', () =>
    import(/* webpackChunkName: 'role-index' */ './role-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/role/index.js